import { ReviewList } from '@/components/feature/shop/review-list';
import { ReviewKioskBanner } from '@/components/feature/shop/review-kiosk-banner';
import { ShopMenu } from '@/components/feature/shop/shop-menu';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './styles.module.scss';
import type { MenuItem, ReviewItem } from '@/types/shop';
import { filterInvalidMenuList } from '@/utils/fnb';

type Props = {
    menuList?: MenuItem[] | null | undefined;
    reviewList?: ReviewItem[];
    showReview?: boolean;
    firstRef?: (node?: Element | null) => void;
    lastRef?: (node?: Element | null) => void;
};

const ReviewMenuSlideVertical = ({ menuList, reviewList, showReview, firstRef, lastRef }: Props) => {
    const { t } = useTranslation();
    const validMenuList = filterInvalidMenuList(menuList || []);
    return (
        <div className="flex flex-col">
            <div className={clsx('flex', { ['gap-[calc(12*var(--vw-unit))]']: menuList && menuList.length > 0 })}>
                <div ref={firstRef} className="relative h-fit">
                    {validMenuList && validMenuList.length > 0 && <ShopMenu tabIndex={6} showReview={showReview} menuList={validMenuList} />}
                </div>

                {showReview && (
                    <ReviewList tabIndex={7} reviewList={reviewList} lastItemRef={lastRef} />
                )}
            </div>

            {showReview && (
                <div className={clsx(styles['review-menu-slides__message'], 'mt-[calc(16*var(--vh-unit))]')}>
                    <span>{'\u203B'}</span>
                    <span>{t('shop.message.recent_merchant_reviews')}</span>
                </div>
            )}
        </div>
    );
};

export default ReviewMenuSlideVertical;
